import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, FormGroup, Popover, Row } from "react-bootstrap";
import ModalImportFromExcel from "../../Pages/ModalImportFromExcel";
import BihamtaTable from "../../Components/BihamtaTable";
import { CloudUploadFill, Download, EyeFill, EyeSlashFill, FileEarmarkExcelFill, Link45deg, List, Search, Trash } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import { getAllGuaranteeHolders, getAssignedCardsList } from "../store/api/GuaranteeApi";
import { useDispatch, useSelector } from "react-redux";
import { attachFile, deleteAttachment, downloadFile, exportToExcel, getAttachmentList } from "../../store/api/CommonFunctions";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalGuaranteeSubProducts from "../Components/ModalGuaranteeSubProducts";
import { Table } from "react-bootstrap";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { isWebApp } from "../../store/api/CommonFunctions";

export default function GuaranteeCardsAssignedToAgencies() {
    const settingNames = ['ProductGrouppingType'];
    const dispatch = useDispatch();
    const { register, handleSubmit } = useForm();
    const dateFilters = useRef({});
    const inputAttach = useRef();
    const [showFilter, setShowFilter] = useState(true);
    const [showImportExl, setShowImportExl] = useState(false);
    const [exlModalInfo, setExlModalInfo] = useState(null);
    const [currentCard, setCurrentCard] = useState(null);
    const currentCardID = useRef();
    const [popProduct, setPopProduct] = useState({ show: false });
    const [cancelConfirm, setCancelConfirm] = useState(false);
    //const [dataList, setDataList] = useState({ Data: [] });
    const [pending, setPending] = useState(false);
    const [holderList, setHolderList] = useState(null);
    const [modalSubProducts, setModalSubProducts] = useState({ show: false });
    const [attachList, setAttachList] = useState(null);
    const currentHolder = useRef(-1);
    const [popAgency, setPopAgency] = useState({ show: false });
    const [popStorage, setPopStorage] = useState({ show: false });
    const filterData = useSelector(state => state.guaranteeCardsReducer.assignedCardsFilter);
    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const pgType = Array.isArray(systemSettings ?? "") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;


    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "شماره گارانتی", colName: "GuaranteeCardNo", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "شماره سریال", colName: "SerialNumber", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "کد محصول", colName: "ProductCode" },
        { colTitle: "نام/نوع محصول", colName: "ProductName" },
        { colTitle: "مدل محصول", colName: "ProductModel" },
        { colTitle: "آغاز گارانتی", colName: "PGuaranteeStartDate" },
        { colTitle: "پایان گارانتی", colName: "PGuaranteeEndDate" },
        { colTitle: "تاریخ تولید", colName: "PProductCreationDate" },
        { colTitle: "تاریخ تخصیص", colName: "PAssignToAgencyDate" },
        { colTitle: "استفاده شده", colName: "IsUsedInServices", colType: "boolean" },
        { colTitle: "خارج از گارانتی", colName: "IsGuaranteeCanceled", colType: "boolean" },
        { colTitle: "شرح ابطال", colName: "CancelDescription" },
        { colTitle: "مشخصات مشتری", colName: "CustomerName" },
        {colTitle:"مشخصات نماینده", colName:"AgencyName"}
    ]
    function loadAttachList(row) {
        currentCardID.current = row.CardID;
        getAttachmentList(row.CardID, "GuaranteeCardAttachment", setAttachList);

    }
    function delAttach(id) {
        dispatch(deleteAttachment(id, "DocumentAttachment", () => getAttachmentList(currentCardID.current, "GuaranteeCardAttachment", setAttachList)));
    }
    function attach() {
        dispatch(attachFile(inputAttach.current, currentCardID.current, "GuaranteeCardAttachment", () => getAttachmentList(currentCardID.current, "GuaranteeCardAttachment", setAttachList)));
    }
    const popAttachments = (
        (<Popover id="popAttachments" style={{ maxWidth: "500px", minWidth: "500px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Button className="btn-input-tiny" style={{ top: "1px", left: "1px" }} onClick={attach}><CloudUploadFill size={25} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>تاریخ پیوست</th>
                            <th style={{ width: "50%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            attachList && Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "65%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "GuaranteeCardAttachment")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    const rowButtons = [
        { type: "overlay", tooltip: "پیوست ها", overlay: popAttachments, onclick: loadAttachList, icon: <Link45deg color="blue" size={18} /> },
        { type: "common", tooltip: "فهرست قطعات", title: "فهرست قطعات", icon: <List color="green" size={18} />, onclick: showSubProducts }
    ]
    function showSubProducts(row) {
        setModalSubProducts({
            cardID: row.CardID,
            show: true,
            productName: row.ProductName,
            productModel: row.ProductModel,
            serialNumber: row.SerialNumber
        })
    }
    function toExcel() {
        const url = "api/GuarantyAPI/SearchCards";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("GuaranteeCardsAssignedToAgencies", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        //Date Filters
        {
            let date = document.getElementsByName("CreateFromDate")[0].value;
            if (date !== "") {
                data.CreateFromDate = dateFilters.current.CreateFromDate;
            }
            else {
                dateFilters.current.CreateFromDate = null;
            }
            date = document.getElementsByName("CreateFromDate")[0].value;
            if (date !== "") {
                data.CreateFromDate = dateFilters.current.CreateFromDate;
            }
            else {
                dateFilters.current.CreateFromDate = null;
            }
            date = document.getElementsByName("GuaranteeStartFromDate")[0].value;
            if (date !== "") {
                data.GuaranteeStartFromDate = dateFilters.current.GuaranteeStartFromDate;
            }
            else {
                dateFilters.current.GuaranteeStartFromDate = null;
            }
            date = document.getElementsByName("GuaranteeStartToDate")[0].value;
            if (date !== "") {
                data.GuaranteeStartToDate = dateFilters.current.GuaranteeStartToDate;
            }
            else {
                dateFilters.current.GuaranteeStartToDate = null;
            }
            date = document.getElementsByName("GuaranteeEndFromDate")[0].value;
            if (date !== "") {
                data.GuaranteeEndFromDate = dateFilters.current.GuaranteeEndFromDate;
            }
            else {
                dateFilters.current.GuaranteeEndFromDate = null;
            }
            date = document.getElementsByName("GuaranteeEndToDate")[0].value;
            if (date !== "") {
                data.GuaranteeEndToDate = dateFilters.current.GuaranteeEndToDate;
            }
            else {
                dateFilters.current.GuaranteeEndToDate = null;
            }
            date = document.getElementsByName("ActiveFromDate")[0].value;
            if (date !== "") {
                data.ActiveFromDate = dateFilters.current.ActiveFromDate;
            }
            else {
                dateFilters.current.ActiveFromDate = null;
            }
            date = document.getElementsByName("ActiveToDate")[0].value;
            if (date !== "") {
                data.ActiveToDate = dateFilters.current.ActiveToDate;
            }
            else {
                dateFilters.current.ActiveToDate = null;
            }
            date = document.getElementsByName("PurchaseFromDate")[0].value;
            if (date !== "") {
                data.PurchaseFromDate = dateFilters.current.PurchaseFromDate;
            }
            else {
                dateFilters.current.PurchaseFromDate = null;
            }
            date = document.getElementsByName("PurchaseToDate")[0].value;
            if (date !== "") {
                data.PurchaseToDate = dateFilters.current.PurchaseToDate;
            }
            else {
                dateFilters.current.PurchaseToDate = null;
            }
        }
        ///////////
        if (!data.Take) {
            data.Take = 10;
        }
        data.HolderID = currentHolder.current;
        data.Skip = 0;
        dispatch(getAssignedCardsList(data));
    }
    // function showModalProduct() {
    //     const onSetData = (data) => {
    //         if (data?.ProductID) {
    //             setCurrentCard({
    //                 ...currentCard,
    //                 ProductID: data.ProductID,
    //                 ProductCode: data.ProductCode,
    //                 ProductName: data.ProductName,
    //                 ProductModel: data.ProductModel
    //             })
    //         }

    //     }
    //     setPopProduct({
    //         show: true,
    //         setProductData: onSetData
    //     })
    // }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        getAllGuaranteeHolders(null, setHolderList);
        dispatch(getSystemSettings(settingNames));
    }, []);
    return (
        <div className="container-fluid mt-2">
            <br />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} defaultSalePrice=""
                defaultSalePriceLabel="" defaultStorages="" />
            <ModalSelectStaff setPopSelectStaff={setPopAgency} popData={popAgency} />
            <Card style={{ textAlign: "right" }}>
                {
                    exlModalInfo &&
                    <ModalImportFromExcel show={showImportExl} setShow={setShowImportExl}
                        submitData={exlModalInfo.submitData}
                        pageFields={exlModalInfo.pageFields}
                        formName={exlModalInfo.formName} />
                }
                <ModalGuaranteeSubProducts popData={modalSubProducts} setPopData={setModalSubProducts} productGrouppingType={pgType} />
                <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faClipboardList} size="lg" />&nbsp;
                    گزارش کارتهای تخصیصی به نماینده
                </Card.Header>
                <Card.Body className="bodyStyle">

                    <form readOnly onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder mt-3">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>نام برند: </label>
                                {
                                    Array.isArray(holderList ?? "") ?
                                        <select className="form-control" onChange={e => currentHolder.current = e.target.value}>
                                            <option value="">انتخاب کنید</option>
                                            {holderList.map((item, i) =>
                                                <option key={i} value={item.ID}>{item.HolderName}</option>)
                                            }
                                        </select> :
                                        <div className="form-control">
                                            <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                        </div>
                                }
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">نام/نوع کالا: </label>
                                <Form.Control name="ProductName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">مدل کالا: </label>
                                <Form.Control name="ProductModel" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">شماره گارانتی: </label>
                                <Form.Control name="GuaranteeCardNo" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">شماره سریال: </label>
                                <Form.Control name="SerialNumber" ref={register({})} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">نام فروشگاه: </label>
                                <Form.Control name="ShopName" ref={register({})} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingLeft: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="تاریخ ثبت از">تاریخ ثبت از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="CreateFromDate"
                                    onChange={value => dateFilters.current.CreateFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingRight: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="تاریخ ثبت تا">تاریخ ثبت تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="CreateToDate"
                                    onChange={value => dateFilters.current.CreateToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group"  style={{paddingLeft: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="آغاز گارانتی از">آغاز گارانتی از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="GuaranteeStartFromDate"
                                    onChange={value => dateFilters.current.GuaranteeStartFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingRight: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="آغاز کارانتی تا">آغاز گارانتی تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="GuaranteeStartToDate"
                                    onChange={value => dateFilters.current.GuaranteeStartToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingLeft: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="پایان گارانتی از">پایان گارانتی از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="GuaranteeEndFromDate"
                                    onChange={value => dateFilters.current.GuaranteeEndFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingRight: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="پایان گارانتی تا">پایان گارانتی تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="GuaranteeEndToDate"
                                    onChange={value => dateFilters.current.GuaranteeEndToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingLeft: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="تاریخ فروش از">تاریخ فروش از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ActiveFromDate"
                                    onChange={value => dateFilters.current.ActiveFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingRight: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="تاریخ فروش تا">تاریخ فروش تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ActiveToDate"
                                    onChange={value => dateFilters.current.ActiveToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingLeft: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="تاریخ خرید از">تاریخ خرید از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="PurchaseFromDate"
                                    onChange={value => dateFilters.current.PurchaseFromDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingRight: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="تاریخ خرید تا">تاریخ خرید تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="PurchaseToDate"
                                    onChange={value => dateFilters.current.PurchaseToDate = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group" style={{paddingLeft: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="وضعیت استفاده">وضعیت استفاده: </label>
                                <select className="form-control" name="IsUsedInService" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>استفاده نشده</option>
                                    <option value={true}>استفاده شده</option>
                                </select>
                            </Col>
                            <Col md={1} className="form-group" style={{paddingRight: isWebApp()?"4px":"unset"}}>
                                <label className="ellipsisLabel" title="وضعیت کارت">وضعیت کارت: </label>
                                <select className="form-control" name="CardStatus" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={1}>عادی</option>
                                    <option value={2}>لیست سیاه</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel" title="وضعیت ابطال">وضعیت ابطال: </label>
                                <select className="form-control" name="IsCanceled" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>گارانتی معتبر</option>
                                    <option value={true}>خارج از گارانتی</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">شماره سریال قطعه:</label>
                                <Form.Control name="SubProductSerial" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">نام نماینده:</label>
                                <Form.Control name="AgencyName" ref={register({})} />
                            </Col>                            
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">تعداد در صفحه: </label>
                                <select className="form-control" name="Take" ref={register({})}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={500}>500</option>

                                </select>
                            </Col>
                        </Row>
                        <div className="mt-1">
                            <Button type="submit" className="group-Btn-large" variant="secondary"><Search size={18} />&nbsp;جستجوی کارت </Button>
                        </div>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable filterData={filterData} searchMethod={(data) => dispatch(getAssignedCardsList(data))} columns={tableCols} rowButtons={rowButtons}
                        reducerName="guaranteeCardsReducer" objectName="assignedCardsList" hasPaging className="mt-0" style={{ whiteSpace: "nowrap" }} />
                </Card.Body>
            </Card>
        </div>
    )
}